//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WasteCollectList from "./WasteCollectList";
import WasteDealList from "./WasteDealList";
export default {
  name: 'WasteList',
  components: {
    WasteCollectList: WasteCollectList,
    WasteDealList: WasteDealList
  },
  data: function data() {
    return {
      tabKey: '1'
    };
  }
};